// extracted by mini-css-extract-plugin
export default {"input":"Input_input__gDJOF","OTPInput":"Input_OTPInput__7vxDN"};